import { render, staticRenderFns } from "./AddEditSkillTest.vue?vue&type=template&id=2be99814"
import script from "./AddEditSkillTest.vue?vue&type=script&lang=js"
export * from "./AddEditSkillTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports